import React from "react";
import CTAButtonText from "./CTAButtonText";

function CTATextContainer(params) {
    return (
        <div className="cta-text-container">
            <p>Choose a plan that is right for you. Either ad-free or with ads.</p>
            <CTAButtonText context={params?.context} category={params?.category} />
        </div>
    );
}

export default CTATextContainer;